import { render, staticRenderFns } from "./homeTop.vue?vue&type=template&id=877be094&scoped=true&"
import script from "./homeTop.vue?vue&type=script&lang=ts&"
export * from "./homeTop.vue?vue&type=script&lang=ts&"
import style0 from "./homeTop.vue?vue&type=style&index=0&id=877be094&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "877be094",
  null
  
)

export default component.exports